export default function StudentMessages(){
    return <h1>Student Messages</h1>
}